import { ChangeDetectionStrategy, Component, inject, ViewEncapsulation } from '@angular/core';
import type { ApiTypes } from '@hyundai/ng-common-lib';
import { DealerFeature, RouterLinkDirective, ServicesFeature } from '@hyundai/ng-common-lib';
import { M000C010ImageComponent, M000C040LoadingSpinnerComponent } from '@hyundai/ui';
import { Store } from '@ngrx/store';
import { CHECKOUT_STEP_TOKEN, CheckoutStepComponent } from '@pixelgenau/ngx-checkouts';

@Component({
    selector: 'app-service-form-thanks-step',
    standalone: true,
    templateUrl: './service-form-thanks-step.component.html',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [M000C010ImageComponent, RouterLinkDirective, M000C040LoadingSpinnerComponent],
    providers: [{ provide: CHECKOUT_STEP_TOKEN, useExisting: ServiceFormThanksStepComponent }],
})
export default class ServiceFormThanksStepComponent extends CheckoutStepComponent {
    store = inject(Store);
    dealer = this.store.selectSignal(DealerFeature.state.selectLoadedDealer);
    dealerName = this.store.selectSignal(DealerFeature.state.selectDealerName);
    success = this.store.selectSignal(ServicesFeature.state.selectSubmitFormSuccess);
    loading = this.store.selectSignal(ServicesFeature.state.selectSubmitFormLoading);

    override showStepperMenu(): boolean {
        return false;
    }

    override showSidebar(): boolean {
        return false;
    }

    override activate(): void {
        const data = this.submitData() as unknown as ApiTypes.ServiceFormPayload;
        this.store.dispatch(ServicesFeature.actions.submitServiceForm({ payload: data }));
        super.activate();
    }
}
